import React, { memo } from 'react';
import { PromotionElement } from './PromotionElement';
/**
 * @tdr
 */
var ProductPodPromotions = memo(function (_a) {
    var currentSaleUnitPrice = _a.currentSaleUnitPrice, promotions = _a.promotions, productId = _a.productId, highlightColor = _a.highlightColor, _b = _a.withChevron, withChevron = _b === void 0 ? false : _b;
    if (!promotions.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, promotions.map(function (promotion) { return (React.createElement(PromotionElement, { currentSaleUnitPrice: currentSaleUnitPrice, productId: productId, promotion: promotion, highlightColor: highlightColor, withChevron: withChevron, key: "".concat(productId, "_").concat(promotion.promotionId) })); })));
});
ProductPodPromotions.displayName = 'ProductPodPromotions';
export default ProductPodPromotions;
//# sourceMappingURL=ProductPodPromotions.js.map